import { render } from "./PrivacyPolicyView.vue?vue&type=template&id=f70eef5a&ts=true"
import script from "./PrivacyPolicyView.vue?vue&type=script&lang=ts"
export * from "./PrivacyPolicyView.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Deployment\\Member Portal\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__